import "./Print-preview.scss"
import DynamicChart from "./DynamicD3Chart"
import Markdown from "react-markdown"
import sanitizeHtml from "sanitize-html"
import { exportElementToPdf } from "./html-to-pdf-converter"

type PrintableResponseItem = {
  id?: string
  message?: string
  reportTitle?: string
}

type PrintPreviewProps = {
  printableResponse?: PrintableResponseItem[]
  reportDetails?: any
  togglePrintPreview?: () => void
}

const PrintPreview = ({
  printableResponse = [],
  reportDetails,
  togglePrintPreview
}: PrintPreviewProps) => {
  const downloadPDFHandler = async () => {
    try {
      await exportElementToPdf({
        elementId: `printable-preview-${printableResponse?.[0]?.id}`,
        fileName: `${reportDetails?.equipmentName || ""}-ai-report.pdf`,
        documentTitle: `${reportDetails?.equipmentName || ""}-ai-report`
      })
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <div className="print-preview-container">
      <div className="print-content">
        <header>
          <p>Preview</p>
          <span onClick={togglePrintPreview} className="close-button">
            X
          </span>
        </header>
        <div
          id={`printable-preview-${printableResponse?.[0]?.id}`}
          className="messages-container"
        >
          {printableResponse.map((data, i) => {
            return (
              <div key={`print-preview-${i}`} className="message">
                {i === 0 ||
                data?.reportTitle !==
                  printableResponse?.[i - 1]?.reportTitle ? (
                  <h5 className="title">{data?.reportTitle}</h5>
                ) : null}
                {data?.message?.includes("d3.select") ? (
                  <DynamicChart
                    isPreview={true}
                    llmResponse={data?.message}
                    id={data?.id}
                  />
                ) : data?.message?.includes("<html>") ||
                  data?.message?.includes("<ul>") ||
                  data?.message?.includes("<p>") ||
                  data?.message?.includes("<b>") ||
                  data?.message?.includes("<table>") ||
                  data?.message?.includes("<div") ? (
                  <div
                    className="content"
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHtml(data?.message)
                    }}
                  ></div>
                ) : (
                  <Markdown>{data?.message}</Markdown>
                )}
              </div>
            )
          })}
        </div>
        <footer>
          <span onClick={downloadPDFHandler} className="download-pdf-button">
            DOWNLOAD PDF
          </span>
        </footer>
      </div>
    </div>
  )
}

export default PrintPreview
